import { graphql } from 'gatsby';
import parse from 'html-react-parser';
import {
  StyledTooltipContent,
  StyledLink,
  StyledIconWithoutLink,
  StyledIcon,
  StyledLinkIconWrapper,
  StyledIconWrapper,
} from './LanguagesGridBlockV3Item.styles';

interface LanguagesGridBlockV3ItemProps {
  item: Queries.LANGUAGES_GRID_BLOCK_V3_ITEMFragment;
}

const LanguagesGridBlockV3Item = ({ item }: LanguagesGridBlockV3ItemProps) => {
  if (!item?.elements) {
    return null;
  }

  const { icon, link, tooltip } = item.elements;
  const iconUrl = icon?.value?.url;
  const iconDescription = icon?.value?.description || 'Language Icon';
  const hasLink = link?.value?.__typename === 'kontent_item_link';
  const tooltipId = tooltip?.value?.system?.id;
  const tooltipTheme = tooltip?.value?.tooltipElements?.theme?.value;
  const tooltipContent = tooltip?.value?.tooltipElements?.content?.value;
  const liCount = (tooltipContent?.match(/<li>/g) ?? []).length;
  const ulCount = (tooltipContent?.match(/<ul>/g) ?? []).length;

  const iconImage = <StyledIcon src={iconUrl} alt={iconDescription} />;

  return (
    <>
      {hasLink ? (
        <StyledLink data-tooltip-id={tooltipId} {...link.value}>
          <StyledLinkIconWrapper>{iconImage}</StyledLinkIconWrapper>
        </StyledLink>
      ) : (
        <StyledIconWithoutLink data-tooltip-id={tooltipId}>
          <StyledIconWrapper>{iconImage}</StyledIconWrapper>
        </StyledIconWithoutLink>
      )}
      {tooltipContent && (
        <StyledTooltipContent
          id={tooltipId}
          className={`tooltip theme-${tooltipTheme}`}
          liCount={liCount}
          ulCount={ulCount}
        >
          {parse(tooltipContent)}
        </StyledTooltipContent>
      )}
    </>
  );
};

export default LanguagesGridBlockV3Item;

export const fragment = graphql`
  fragment LANGUAGES_GRID_BLOCK_V3_ITEM on kontent_item_languages_grid_block_v3_item {
    system {
      id
    }
    elements {
      icon {
        value {
          description
          url
          width
          height
        }
      }
      link {
        value {
          ...LINK
        }
      }
      tooltip {
        value {
          ...TOOLTIP
        }
      }
    }
  }
`;
